import { useUserStore } from '@/stores/user'

import { SegmentedProgressBar } from './SegmentedProgressBar'

export function VolumeUsageSegmentedBar() {
  const userStore = useUserStore()

  if (userStore.isOrderExpired) {
    const expiredSnapshotUsageInGB = userStore.expiredOrderUsage.globalSnapUsageMB / 1024
    const expiredPartVolumeUsageInGB = userStore.expiredOrderUsage.partVolumeUsageMB / 1024
    const partVolumeLastQuotaInGB = userStore.partVolume?.last_quota_gb || 0

    if (partVolumeLastQuotaInGB <= 0) {
      return <SegmentedProgressBar value={0} secondValue={0} />
    }

    const expiredSnapshotUsage = expiredSnapshotUsageInGB / partVolumeLastQuotaInGB
    const expiredSnapshotAndCloudUsage = expiredPartVolumeUsageInGB / partVolumeLastQuotaInGB

    return (
      <SegmentedProgressBar
        value={expiredSnapshotUsage}
        secondValue={expiredSnapshotAndCloudUsage}
      />
    )
  }

  const snapshotUsageInGB = userStore.globalSnapVolume?.quota_gb || 0
  const partVolumeUsageInGB = (userStore.partVolume?.usage_mb || 0) / 1024
  const partVolumeQuotaInGB = userStore.partVolume?.quota_gb || 0

  if (partVolumeQuotaInGB <= 0) {
    return <SegmentedProgressBar value={0} secondValue={0} />
  }

  const snapshotUsage = snapshotUsageInGB / partVolumeQuotaInGB
  const snapshotAndCloudUsage = partVolumeUsageInGB / partVolumeQuotaInGB

  return <SegmentedProgressBar value={snapshotUsage} secondValue={snapshotAndCloudUsage} />
}
